import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const AdditionalSLARolesRBAC = {
  pageID: 'c5a0dffa2ba2aa95f8f692ec21339240',
  elementID: {
    TurnOffAdditionalSLA: 'a3b71742fde6b1c0f0447a639c92d074',
    ViewPage: 'f402bac4050dbc4c31865031625af044',
    CreateAdditionalSLA: 'e7d3a693a67c0b3e3426037fc647a635',
    ExtendAdditionalSLA: '41834392e3b13165710bc2fab0bc36e6',
  },
} as const

export const useRBACAdditionalSLAPage = createUseRBAC(AdditionalSLARolesRBAC.elementID)

export type UseRBACAdditionalSLAPageType = ReturnType<typeof useRBACAdditionalSLAPage>
